<template>
    <!--Tile Wrapper-->
    <div
        class="relative grid h-full w-full"
        :class="{
            'min-h-[250px]': block.Height === 'auto',
        }"
        :style="customHeight"
    >
        <component
            :is="tileComponent"
            :tile="block"
            :data-theme="block.ColorTheme"
            :data-mode="mode"
            class="absolute inset-0"
            :is-active="isActive"
            :class="{
                'has-divider': block.DividerBeforeTile && block.ImageType === 'none',
            }"
        />
    </div>
</template>

<script setup>
    const props = defineProps({
        block: Object,
        isActive: Boolean,
    })

    const tileModules = import.meta.glob('./tiles/*.vue')

    const tileComponent = defineAsyncComponent(() => {
        const tileType = props.block?.ImageType ?? 'none'
        const tile = tileModules[`./tiles/${tileType}.vue`]
        return tile ? tile() : Promise.reject(new Error(`Unknown tile type: ${tileType}`))
    })

    const customHeight = computed(() => {
        if (props.block?.Height !== 'custom') {
            return ''
        }

        return {
            height: `${props.block?.CustomHeight}px`,
        }
    })

    const mode = computed(() => {
        switch (props.block?.ColorPalette) {
            case 'color-subtle':
                return 'brand'
            case 'color-invert':
                return 'brand-invert'
            default:
                return props.block?.ColorPalette
        }
    })
</script>

<style scoped>
    @reference 'tailwindcss';

    .has-divider {
        @apply relative;
    }
    .has-divider:before {
        content: '';
        @apply absolute left-0 h-px w-full bg-(--shape-brand-accent) lg:my-10 lg:h-full lg:w-px;
    }
</style>
